export function getLocale() {
  const { navigator } = window;
  return typeof navigator === 'undefined'
    ? 'en'
    : (
        (navigator.languages && navigator.languages[0]) ||
        navigator.language ||
        navigator.userLanguage ||
        'en'
      ).toLowerCase();
}
export default getLocale;
